import styled from 'styled-components';

export const Container = styled.div`
  height: ${({ height }) => height}vw;
  max-height: 379px;
  display: flex;
  align-items: center;
`;



// WEBPACK FOOTER //
// ./src/components/dividers/styles/imageOnly.style.js